import { render } from "./EditPublicationPage.vue?vue&type=template&id=2e7d1f3b&ts=true"
import script from "./EditPublicationPage.vue?vue&type=script&lang=ts"
export * from "./EditPublicationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__